module.exports = __webpack_public_path__ + "static/img/2026-god-bel-zhenschiny.182082bc.jpg";